export const accountSpecialCircumstancesTypePathName = 'account-special-circumstances-type';
export const accountInteractionPurposePathName = 'account-interaction-purpose';
export const accountInteractionResultPathName = 'account-interaction-result';
export const accountTagTypePathName = 'account-tag-type';
export const accountGroupPathName = 'account-group';
